import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ChargePartnerCallerCreditsInput } from '@/models/partnerCaller';

export const chargePartnerCallerCredits = async ({
  partnerCode,
  phoneNumber,
  requestId,
  amount,
  currency,
  notes,
}: ChargePartnerCallerCreditsInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ChargePartnerCallerCredits(
        $partnerCode: String!
        $phoneNumber: String!
        $requestId: String!
        $amount: Float!
        $currency: String!
        $notes: String!
      ) {
        chargePartnerCallerCredits(
          partnerCode: $partnerCode
          phoneNumber: $phoneNumber
          requestId: $requestId
          amount: $amount
          currency: $currency
          notes: $notes
        )
      }
    `),
    variables: {
      partnerCode,
      phoneNumber,
      requestId,
      amount,
      currency,
      notes,
    },
  });

  return response.data?.chargePartnerCallerCredits ?? false;
};
